var exports =
  [
    {id: 'nl', display: 'Dutch'},
    {id: 'de', display: 'German'},
    {id: 'en', display: 'English'},
    {id: 'fr', display: 'French'},
    {id: 'at', display: 'German'},
    {id: 'pl', display: 'Polish'},
    {id: 'it', display: 'Italian'},
    {id: 'ch', display: 'Swiss'}
  ];

module.exports = exports;



// WEBPACK FOOTER //
// /src/components/Util/LanguageList.js